import React from 'react';
import ReactDOM from 'react-dom/client';
import Silk from './components/SilkBackground.jsx';
import Aurora from './components/Aurora.jsx';
import Waves from './components/Waves.jsx';

// Initialize React components when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    console.log('Main.js loaded - initializing React components');
    
    // Initialize Global Silk Background for navbar area - DISABLED
    // const globalSilkContainer = document.getElementById('global-silk-background');
    // if (globalSilkContainer) {
    //     console.log('Mounting global silk background');
    //     const globalRoot = ReactDOM.createRoot(globalSilkContainer);
    //     globalRoot.render(
    //         React.createElement(Silk, {
    //             speed: 1.5,
    //             scale: 2.0,
    //             color: "#5885af",
    //             noiseIntensity: 0.8,
    //             rotation: 0.02
    //         })
    //     );
    // }
    
    // Initialize Waves Background for hero section (replaces Silk)
    const heroWavesContainer = document.getElementById('hero-waves-background');
    if (heroWavesContainer) {
        console.log('🌊 Hero waves container found');
        
        // Clean initialization - no workaround needed
        const heroWavesRoot = ReactDOM.createRoot(heroWavesContainer);
        heroWavesRoot.render(
            React.createElement(Waves, {
                lineColor: "#5885af",
                backgroundColor: "#1a2b47",
                waveSpeedX: 0.02,
                waveSpeedY: 0.01,
                waveAmpX: 40,
                waveAmpY: 20,
                friction: 0.9,
                tension: 0.01,
                maxCursorMove: 120,
                xGap: 12,
                yGap: 36
            })
        );
        console.log('🌊 Waves component initialized');
    }

    // Initialize Sandbox Silk Background (for testing page)
    const sandboxSilkContainer = document.getElementById('silk-background');
    if (sandboxSilkContainer) {
        console.log('Mounting sandbox silk background');
        const sandboxSilkRoot = ReactDOM.createRoot(sandboxSilkContainer);
        sandboxSilkRoot.render(
            React.createElement(Silk, {
                speed: 3,
                scale: 1.2,
                color: "#5885af",
                noiseIntensity: 1.8,
                rotation: 0.1
            })
        );
    }

    // Initialize Sandbox Aurora Background (for testing page)
    const sandboxAuroraContainer = document.getElementById('aurora-background');
    if (sandboxAuroraContainer) {
        console.log('Mounting sandbox aurora background');
        const sandboxAuroraRoot = ReactDOM.createRoot(sandboxAuroraContainer);
        sandboxAuroraRoot.render(
            React.createElement(Aurora, {
                colorStops: ["#5227FF", "#7cff67", "#5227FF"],
                amplitude: 4.0,
                blend: 0.8,
                speed: 1.0
            })
        );
    }

    // Initialize Sandbox Waves Background (for testing page)
    const sandboxWavesContainer = document.getElementById('waves-background');
    if (sandboxWavesContainer) {
        console.log('Mounting sandbox waves background');
        const sandboxWavesRoot = ReactDOM.createRoot(sandboxWavesContainer);
        sandboxWavesRoot.render(
            React.createElement(Waves, {
                lineColor: "#fff",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                waveSpeedX: 0.02,
                waveSpeedY: 0.01,
                waveAmpX: 40,
                waveAmpY: 20,
                friction: 0.9,
                tension: 0.01,
                maxCursorMove: 120,
                xGap: 12,
                yGap: 36
            })
        );
    }

    // Existing counter animation
    function animateCounters() {
        const counters = document.querySelectorAll('.counter');
        
        counters.forEach(counter => {
            const target = parseInt(counter.getAttribute('data-target'));
            const current = parseInt(counter.innerText);
            const increment = target / 200;
            
            if (current < target) {
                counter.innerText = Math.ceil(current + increment);
                setTimeout(() => animateCounters(), 10);
            } else {
                counter.innerText = target;
            }
        });
    }

    // Initialize counters when they come into view
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounters();
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe counter elements
    document.querySelectorAll('.counter').forEach(counter => {
        observer.observe(counter);
    });
});
